<template>
    <div class="contact__form">
        <form action="https://formspree.io/reception@lgiguere.com" method="POST">
          <div class="contact__form--container">
            <div class="contact__form--container--group"  :class="{invalid: $v.firstname.$error }" id="firstname">
              <input :class="{ notempty: firstnameNotEmpty }" type="text" id="firstname" name="firstname" @blur="$v.firstname.$touch()" v-model="firstname">
              <label for="firstname">{{ $t("contactTranslate.contactForm.firstname") }}*</label>
            </div>
            <div class="contact__form--container--group"  :class="{invalid: $v.lastname.$error}" id="lastname">
              <input :class="{ notempty: lastnameNotEmpty }" type="text" name="lastname" id="lastname" @blur="$v.lastname.$touch()" v-model="lastname">
              <label for="lastname">{{ $t("contactTranslate.contactForm.lastname") }}*</label>
            </div>
            <div class="contact__form--container--group"  :class="{invalid: $v.phone.$error}" id="phone">
              <input :class="{ notempty: phoneNotEmpty }" type="tel" name="phone" id="phone" @blur="$v.phone.$touch()" v-model="phone">
              <label for="phone">{{ $t("contactTranslate.contactForm.phone") }}*</label>
            </div>
            <div class="contact__form--container--group" :class="{invalid: $v.email.$error}">
              <input :class="{ notempty: emailNotEmpty }" type="email" name="_replyto" id="email" @blur="$v.email.$touch()" v-model="email">
              <label for="email">{{ $t("contactTranslate.contactForm.email") }}*</label>
            </div>
            <div class="contact__form--container--group" id="textarea" :class="{invalid: $v.email.$error}">
              <textarea :class="{ notempty: messageNotEmpty }" id="message" name="message" rows="5" @blur="$v.message.$touch()" v-model="message"></textarea>
              <label class="label--textarea" for="message">{{ $t("contactTranslate.contactForm.message") }}*</label>
            </div>

            <button :disabled="$v.$invalid" class="submit">Envoyer</button>

          </div>

          <!-- <div class="contact__form--checkbox">
            <label for="checkbox">
              {{ $t("contactTranslate.contactForm.messageCheckbox") }}
              <input type="checkbox" name="checkbox" id="checkbox" v-model="checkbox">
              <span></span>
            </label>
          </div> -->

          <input type="hidden" name="validateCheckbox" id="validateCheckbox" @blur="$v.validateCheckbox.$touch()" v-model="validateCheckbox">

        </form>

        <!-- <div class="contact__form--message">
          <a @click="viewMessage =! viewMessage" class="contact__form--message--opener">{{ $t("contactTranslate.contactForm.terms") }}</a>
          <p :class="{ 'view-message': viewMessage }" class="contact__form--message--terms">{{ $t("contactTranslate.contactForm.messageToAccept") }}</p>
        </div> -->

      </div>
</template>

<script>

    import {required, email} from 'vuelidate/lib/validators'

    export default {
      data () {
        return {
            firstname: '',
            firstnameNotEmpty: false,
            phone: '',
            phoneNotEmpty: false,
            lastname: '',
            lastnameNotEmpty: false,
            email: '',
            emailNotEmpty: false,
            message: '',
            messageNotEmpty: false,
            checkbox: false,
            validateCheckbox: '',
            locale: 'fr',
            viewMessage: false
        }
      },
      validations() {
        return {
          email: {
            required,
            email
          },
          firstname: {
            required
          },
          lastname: {
            required
          },
          phone: {
            required
          },
          message: {
            required
          }
        }
      },
      watch: {
        locale (val) {
          this.$i18n.locale = val
        },
        firstname() {
          if (this.firstname != '') {
            this.firstnameNotEmpty = true;
          } else {
            this.firstnameNotEmpty = false;
          }
        },
        lastname() {
          if (this.lastname != '') {
            this.lastnameNotEmpty = true;
          } else {
            this.lastnameNotEmpty = false;
          }
        },
        phone() {
          if (this.phone != '') {
            this.phoneNotEmpty = true;
          } else {
            this.phoneNotEmpty = false;
          }
        },
        email() {
          if (this.email != '') {
            this.emailNotEmpty = true;
          } else {
            this.emailNotEmpty = false;
          }
        },
        message() {
          if (this.message != '') {
            this.messageNotEmpty = true;
          } else {
            this.messageNotEmpty = false;
          }
        }
      }
    }
</script>

<style scoped>
  .contact__form--container--group.invalid input {
    border-bottom: 1px solid red;
  }
</style>
